import Vue from 'vue'
import '@/i18n/index'

const { i18n } = Vue

export const tableServiceContractHeaders = [
  {
    text: i18n.translate('defaultServiceValues.type'),
    value: 'type',
    width: 200,
  },
  {
    text: i18n.translate('defaultServiceValues.label.price'),
    value: 'price',
    align: 'right',
    width: 100,
  },
  {
    text: i18n.translate('defaultServiceValues.label.taxHost'),
    value: 'host_tax',
    align: 'right',
    width: 100,
  },
  {
    text: i18n.translate('defaultServiceValues.label.discount'),
    value: 'discount',
    align: 'right',
    width: 100,
  },
  {
    value: 'actions',
    align: 'end',
    width: 120,
  },
]
